import type { ReactElement } from 'react'
import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

import SelectionButton from './SelectionButton'
import type { CommonProps, Value } from './types'
import { useSelectionState } from './useSelectionState'

const styles = tv({
  slots: {
    container: 'gap-y-2.5',
  },
  variants: {
    isHorizontal: {
      true: {
        container: 'flex-row flex-wrap gap-2',
      },
    },
  },
})

const SelectionButtonSet = (props: CommonProps): ReactElement => {
  const { container } = styles({
    isHorizontal: props.layout === 'horizontal',
  })

  const { currentValues, setCurrentValues, onOptionCheck, getIsSelected } = useSelectionState(props)

  const onOptionSelect = (newValue: Value) => {
    if (newValue === currentValues) {
      return
    }

    setCurrentValues(newValue)

    if (typeof props.onValueChange === 'function') {
      props.onValueChange(newValue)
    }
  }

  return (
    <View
      className={container()}
      testID={props.id}
      role={props.selectType === 'radio' ? 'radiogroup' : undefined}
    >
      {props.options
        .filter((option) => !option.hidden)
        .map((option) => (
          <SelectionButton
            {...option}
            key={String(option.value)}
            onPress={props.selectType === 'checkbox' ? onOptionCheck : onOptionSelect}
            isSelected={getIsSelected(option.value)}
            disabled={option.disabled || props.disabled || false}
            selectType={props.selectType}
            hasError={Boolean(props.errorMessage)}
            noOutline={props.noOutline}
            variant={props.variant}
            size={props.size}
          />
        ))}
      {props.errorMessage ? (
        <Text className={caption({ color: 'error' })}>{props.errorMessage}</Text>
      ) : null}
    </View>
  )
}

export default SelectionButtonSet
